import template from './tasksList.html';
import controller from './tasksListCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    opportunityId: '<',
    loanId: '<',
    familyId: '<',
    familyList: '<',
    opportunityTitle: '<',
  },
};
